export const dummytabledata = [
  {
    id: 1,
    name: 'Airi Satou',
    image: 'user/1.jpg',
    date: '2023/04/27',
    invoice: '#PX0101',
    designation: 'System Architect',
    credit: 4.3,
    company: 'Hewlett packard',
    priority: 'High',
    budget: 3142.0,
  },
  {
    id: 2,
    name: ' Thomas Taylor',
    image: 'user/2.png',
    date: '2023/04/22',
    invoice: '#RF304f',
    designation: 'Maintenace service',
    credit: 5.6,
    company: 'Apple Inc.',
    priority: 'Urgent',
    budget: 1234.0,
  },
  {
    id: 3,
    name: 'Michael Morris',
    image: 'user/3.jpg',
    date: '2023/05/21',
    invoice: '#DNJ480',
    designation: 'Junior Technical Author',
    credit: 2.4,
    company: 'Edinburgh',
    priority: 'Low',
    budget: 2345.0,
  },
  {
    id: 4,
    name: 'Tiger Nixon',
    image: 'user/3.png',
    date: '2023/03/09',
    invoice: '#G189d0',
    designation: 'Senior Javascript Developer',
    credit: '2.2',
    company: 'Microsoft',
    priority: 'Medium',
    budget: 7689.0,
  },
  {
    id: 5,
    name: 'Garrett Winters',
    image: 'user/4.jpg',
    date: '2023/04/10',
    invoice: '#31D8FFS',
    designation: 'Accountant',
    credit: 5.8,
    company: 'Tata Co.',
    priority: 'High',
    budget: 2145.0,
  },
  {
    id: 6,
    name: 'Carolyn Jones',
    image: 'user/5.jpg',
    date: '2023/06/12',
    invoice: '#G189D4',
    designation: 'General service',
    credit: 6.4,
    company: 'Google Inc.',
    priority: 'Urgent',
    budget: 2578.0,
  },
  {
    id: 7,
    name: 'Glen Matney',
    image: 'user/6.jpg',
    date: '2023/04/25',
    invoice: '#PX2101',
    designation: 'System Architect',
    credit: 0.3,
    company: 'Mindtree Ltd.',
    priority: 'Low',
    budget: 6538.0,
  },
  {
    id: 8,
    name: 'Ashton Cox',
    image: 'user/7.jpg',
    date: '2023/06/09',
    invoice: '#px0101',
    designation: 'System Architect',
    credit: 7.3,
    company: 'Wipro Ltd.',
    priority: 'Urgent',
    budget: 2121.0,
  },
  {
    id: 9,
    name: 'Tiger Nixon',
    image: 'user/8.jpg',
    date: '2023/01/11',
    invoice: '#G5384H',
    designation: 'General service',
    credit: 6.3,
    company: 'Edinburgh',
    priority: 'High',
    budget: 9546.0,
  },
  {
    id: 10,
    name: 'Brielle Williamson',
    image: 'user/9.jpg',
    date: '2023/04/02',
    invoice: '#E5384H',
    designation: 'System Architect',
    credit: 3.3,
    company: 'Mphasis Ltd',
    priority: 'Medium',
    budget: 4587.0,
  },
  {
    id: 11,
    name: 'Charles Kubik',
    image: 'user/10.jpg',
    date: '2023/05/01',
    invoice: '#JK384H',
    designation: 'System Architect',
    credit: 2.3,
    company: 'Infosys Ltd.',
    priority: 'Low',
    budget: 3140.0,
  },
  {
    id: 12,
    name: 'Brielle Williamson',
    date: '2023/07/04',
    image: 'user/11.png',
    invoice: '#HY5384H',
    designation: 'General service',
    credit: 1.3,
    company: 'Edinburgh',
    priority: 'Low',
    budget: 3014.0,
  },
  {
    id: 13,
    name: 'Kevin Dawson',
    image: 'user/12.png',
    date: '2022/04/06',
    invoice: '#KH384H',
    designation: 'System Architect',
    credit: 5.3,
    company: 'Infosys.',
    priority: 'Urgent',
    budget: 2014.0,
  },
];

export const tableColumns = [
  {
    name: 'Name',
    selector: (row) => row['name'],
    sortable: true,
  },
  {
    name: 'Date',
    selector: (row) => `${row.date}`,
    sortable: true,
  },
  {
    name: 'invoice No.',
    selector: (row) => `${row.invoice}`,
    sortable: true,
  },
  {
    name: 'Job Designation',
    selector: (row) => `${row.designation}`,
    sortable: true,
  },
  {
    name: 'Credit/Debit',
    selector: (row) => row['credit'],
    sortable: true,
  },
  {
    name: 'Company Name',
    selector: (row) => `${row.company}`,
    sortable: true,
  },
  {
    name: 'Priority',
    selector: (row) => row['priority'],
    sortable: true,
  },
  {
    name: 'Budget',
    selector: (row) => row['budget'],
    sortable: true,
  },
];
